import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { UserAuthenticated } from 'src/app/model/user-authenticated.model';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  /**
   * @param HttpRequest<any> request - The intercepted request
   * @param HttpHandler next - The next interceptor in the pipeline
   * @return Observable<HttpEvent<any>>
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addToken(request);
    return next.handle(request)
      // add error handling
      .pipe(
        catchError(
          (error: any, caught: Observable<HttpEvent<any>>) => {
            if (error.status === 401 && this.router.url !== '/login') {
              this.handleAuthError();
              return of(error);
            }
            throw error;
          }
        ),
      );
  }

  /**
   * Handle API authentication errors.
   */
  private handleAuthError() {
    // clear stored credentials; they're invalid
    localStorage.removeItem('HW_USER_TOKEN');
    this.authService.userAuthenticated = null!;
    // navigate back to the login page
    this.router.navigate(['/login']);
  }

  /**
   * Add stored auth token to request headers.
   * @param HttpRequest<any> request - the intercepted request
   * @return HttpRequest<any> - the modified request
   */
  private addToken(request: HttpRequest<any>): HttpRequest<any> {
    if (request.url.includes('/auth/oauth/token')) return request;

    const storedToken = localStorage.getItem('HW_USER_TOKEN');
    if (!storedToken) return request;

    const oauthToken: UserAuthenticated = JSON.parse(storedToken);
    if (!oauthToken?.access_token) return request;

    return request.clone({ setHeaders: { Authorization: `Bearer ${oauthToken.access_token}` } });
  }

}
